import { render } from "./richiestaPagamentoModal.vue?vue&type=template&id=4bfed261&scoped=true&ts=true"
import script from "./richiestaPagamentoModal.vue?vue&type=script&lang=ts"
export * from "./richiestaPagamentoModal.vue?vue&type=script&lang=ts"

import "./richiestaPagamentoModal.vue?vue&type=style&index=0&id=4bfed261&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfed261"]])

export default __exports__